import { Button } from '@televet/kibble-ui/build/components/Button';
import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import React from 'react';
import { ConditionProps } from '../types/conditionalSegments.types';

type SegmentWrapperProps = { children: JSX.Element } & Pick<ConditionProps, 'onDelete'>;

export const SegmentWrapper = ({ children, onDelete }: SegmentWrapperProps): JSX.Element => {
  return (
    <Box borderWidth="1px" borderRadius="lg" p="3" mt="2" bgColor="background.subtle">
      <Flex justify="space-between">
        {children}
        {!!onDelete && <Button variant="ghostNeutral" size="sm" iconName="trashcan" onClick={onDelete} />}
      </Flex>
    </Box>
  );
};
